module.exports = __webpack_public_path__ + "static/media/1998-Graubner-0.4f9c5c53.jpg";